import { FormFieldRow } from '@/components/forms/BookTradeForm/FormFieldRow'
import { BaseStructuredFormFields } from '@/pages/instruments/new-instrument/fields/base-structured.fields'
import { OptionalStructuredFields } from '@/pages/instruments/new-instrument/fields/structured.optional.fields'
import { ContractSideFormField } from '@/pages/instruments/new-instrument/form-fields/ContractSideFormField'
import { ContractTypeField } from '@/pages/instruments/new-instrument/form-fields/ContractTypeFormField'
import { KnockDownInputLevelFormField } from '@/pages/instruments/new-instrument/form-fields/KnockDownInputLevelFormField'
import { ParticipationRateFormField } from '@/pages/instruments/new-instrument/form-fields/ParticipationRateFormField'

export interface VanillaSpreadFormFieldsProps {}

export const VanillaSpreadFormFields: React.FC<VanillaSpreadFormFieldsProps> = ({}) => {
  return (
    <div className="grid gap-6 @2xl:grid-cols-2 @2xl:gap-10">
      <BaseStructuredFormFields />
      <div className={'@container flex flex-col gap-6'}>
        <FormFieldRow>
          <ContractTypeField />
          <ContractSideFormField />
          <ParticipationRateFormField />
          <KnockDownInputLevelFormField />
        </FormFieldRow>
        <OptionalStructuredFields />
      </div>
    </div>
  )
}
